import React, { useState } from 'react';
import styled from 'styled-components';
import { LuTimer } from "react-icons/lu";

const WrappedStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    background-color: rgba(255, 255, 255, 0.85);
    .inner{
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        width: calc(100% - 40px);
        max-width: 400px;
        background-color: #FFFFFF;
        padding: 25px;
        border-radius: 12px;
        margin-top: 20px;

        -webkit-box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
        -moz-box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
        -ms-box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);

        .ico_phone{
            width: 150px;
            img{
                float: left;
                width: 100%;
            }
        }
        .icon{
            display: flex;
            font-size: 70px;
            line-height: 70px;
            margin-bottom: 15px;
            color: #FFD200;
        }
        .title{
            font-weight: 500;
            text-align: center;
        }
        .description{
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            margin-top: 10px;
        }
        .actions{
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            margin-top: 20px;
            .bt_google,
            .bt_appstore{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                background-color: #D80115;
                border: 1px solid #D80115;
                border-radius: 6px;
                padding: 5px;
                width: calc(100% - 40px);
                cursor: pointer;
                .text{
                    font-weight: 500;
                    color: #FFFFFF;
                }
                .ico{
                    width: 25px;
                    margin-left: 5px;
                    img{
                        float: left;
                        width: 100%;
                    }
                }
            }
            .bt_appstore{
                background-color: #FFC600;
                margin-top: 5px;
                border: 1px solid #FFC600;
                .text{
                    color: #000000;
                }
            }
            .bt_notnow{
                cursor: pointer;
                margin-top: 20px;
                font-size: 16px;
                line-height: 16px;
                font-weight: 600;
                color: #D80115;
            }
        }
    }

`

const PopApp = (props) => {

    const { setOpenAppPop } = props;

    const handleGotoStore = (store) => {

        if(store === "google"){
            window.open("https://play.google.com/store/apps/details?id=com.oravian.one.sp", '_blank').focus();
        }

        if(store === "appstore"){
            window.open("https://apps.apple.com/ar/app/somos-protagonistas-2-0/id6467438150", '_blank').focus();
        }

        if(store === "dismiss"){
            setOpenAppPop(false);
        }

    }

    return (
        <WrappedStyled>
            <div className='inner'>
                {/* <div className='ico_phone'>
                    <img src='images/ico_mobilepop.png' />
                </div> */}
                <div className='icon'><LuTimer /></div>
                <div className='title'>¡Importante!</div>
                <div className='description'>Estamos realizando una nueva actualización para garantizarte una mejor experiencia. Sino podés navegar de manera habitual, ingresá en un ratito!</div>
                <div className='actions'>
                    {/* <div className='bt_google' onClick={() => handleGotoStore("google")}>
                        <div className='text'>Google Play</div>
                        <div className='ico'>
                            <img src='images/ico_googleplay.png' />
                        </div>
                    </div>
                    <div className='bt_appstore' onClick={() => handleGotoStore("appstore")}>
                        <div className='text'>App Store</div>
                        <div className='ico'>
                            <img src='images/ico_appstore.png' />
                        </div>
                    </div> */}
                    <div className='bt_appstore' onClick={() => handleGotoStore("dismiss")}>Cerrar</div>
                </div>
            </div> 
        </WrappedStyled>
    );
};

export default PopApp;